import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    loadContainer: {
        height: "100%"
    }
}));
